import { toast } from "react-toastify";
export  const PatientFormValidation = (data) => {
    let isValidated = true;
    console.log("custom id ---", data.custom_id);
    console.log("gender ---", typeof data.gender);
    if (!data.custom_id) {toast.error("Custom ID is required");isValidated = false; }
    if (!data.patient_name) {toast.error("Patient Name is required");isValidated = false; }
    if (!data.phone_number) {
      toast.error("Phone Number  is required");
      isValidated = false;
    }
    if (!data.email) {
      toast.error("Email is required.");
      isValidated = false;
    }
    if (!data.address) {
      toast.error("Address field is required");
      isValidated = false;
    }
    if (typeof data.gender !== "string") {
      toast.error("Gener selection  is required");
      isValidated = false;
    }
    if (!data.dentrino_doctors_manager_id) {
      toast.error("Select a doctor");
      isValidated = false;
    }
    return isValidated;
  };